import { Container, Loader } from 'pixi.js';

import { Emitter } from 'pixi-particles';

export class EmitterUtil {
  /**
   * Generate particles (by playOnceAndDestroy)
   * @param container Parent container
   * @param texnames Name of texture
   * @param jsonname Name of json file
   */
  public static generate(container: Container, texnames: string[], jsonname: string): Emitter {
    const resources = Loader.shared.resources;
    const textures = [];
    for (const texname of texnames) {
      textures.push(resources[texname].texture);
    }
    const emitter = new Emitter(container, textures, resources[jsonname].data);
    emitter.playOnceAndDestroy();
    return emitter;
  }
}
